import RefreshIcon from '@mui/icons-material/Refresh'
import { Card, CardContent, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import React from 'react'
import { useSelector } from 'react-redux'

import TabHeader from '@/app/component/atom/tab-header'
import CustomTooltip from '@/app/component/atom/tooltip'
import { useGetInvoices } from '@/app/module/payments/hooks/use-get-invoices'
import { selectOrgId, selectUserRole } from '@/app/module/user/store/selectors'
import { UserRole } from '@/app/types'

import Invoices from './invoices'

const UsageStatements: React.FC = () => {
  const orgId = useSelector(selectOrgId)
  const role = useSelector(selectUserRole) as UserRole
  const { data, isFetching, refetch } = useGetInvoices()
  const invoices = data?.months || []

  return (
    <Container>
      <TabHeader
        title="Usage Statements"
        subheader="Usage Statements can be downloaded starting with the 6th of the following month."
        action={
          <CustomTooltip title="Reload usage statements">
            <IconButton disabled={isFetching} onClick={() => refetch()}>
              <RefreshIcon />
            </IconButton>
          </CustomTooltip>
        }
      />
      <Content>
        <Invoices invoices={invoices} isFetching={isFetching} orgId={orgId} role={role} />
      </Content>
    </Container>
  )
}

const Container = styled(Card)({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
})

const Content = styled(CardContent)({
  flex: 1,
  overflow: 'hidden',
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  '&:last-child': {
    paddingBottom: 0,
  },
})

export default UsageStatements
